import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

import { useBrand } from '../../BrandContext';
import { withText } from '../../text/textStore';
import getConfig from '../../data/config';

// @ts-expect-error TS7031: Binding element 'text' implicitly has an 'any' type.
const DocumentHead = ({ Text: text }) => {
    const brand = useBrand();

    return (
        <Helmet>
            <link rel="preconnect" href={getConfig('form').baseURL} />
            <link rel="icon" href={`/${brand}_favicon.ico`} />
            <title>{text({ path: 'Title' })}</title>
            <meta name="description" content={text({ path: 'Description' })} />
        </Helmet>
    );
};

DocumentHead.propTypes = {
    Text: PropTypes.func.isRequired
};

export default withText('DocumentHead')(DocumentHead);
